/* eslint-disable no-prototype-builtins */
/* eslint-disable  eqeqeq  */
/* eslint-disable  no-sequences  */
import { DEVICE_TYPES_ENUM, INTEGRATION_TYPE, TASK_SORTING } from './constants/enums'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import { isAfter, isBefore, isEqual, format, addSeconds, sub, subMilliseconds, getUnixTime } from 'date-fns'

import {
  MainTasksData,
  CleanTask,
  Task,
  Categories,
  CleanCategories,
  Category,
  SubTasks,
  SubTask,
} from './config/tasksTypes'
import strings from './constants/strings'
import isSolid from 'is-solid'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import keys from 'constants/keys'
import {
  ICheckbox,
  IGroupCheckbox,
  ITaskOverviewAnalytic,
  IConfigGroup,
  IValidationRules,
  IFileDownload,
  IAllUserTaskPermittedGroup,
  IAllTasks,
  IBuildedTasks,
  IRankingReport,
  IConfigStateGroups,
  ITag,
  IOverviewTask,
} from 'constants/interfaces'
import colors from 'constants/colors'
import { defaultTaskStatuses, OTHER_TASK_VIEW_ID } from 'constants/baseValues'
import { isNumber } from 'lodash'
import { Sorting } from './config/types'
import { FrequencyType } from 'components/NewsFeed/PollTaskForm/utils'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

const formatter = new Intl.NumberFormat('en-GB')

export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const buildStoresByArea = (dirtyStores: any) => {
  const areas = {}
  for (const sid in dirtyStores) {
    if (dirtyStores.hasOwnProperty(sid)) {
      const area = dirtyStores[sid]
      if (!areas[area]) {
        areas[area] = []
        areas[area].push(sid)
      } else {
        areas[area].push(sid)
      }
    }
  }
  return areas
}

export const shakeObject = (obj: any) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key]
    }
  })
  return obj
}

export const isContainExternalLinkPhrase = (link: string) => {
  return link?.includes(keys.EXTERNAL_LINK_PHRASE)
}

export const extractSID = (config: any) => {
  const extractedSID = []
  for (const key in config.stores_details) {
    if (config.stores_details.hasOwnProperty(key)) {
      const sidName = config.stores_details[key]
      extractedSID.push({ value: key, label: sidName })
    }
  }
  return extractedSID
}

export const getStoresLength = (storesByArea: any) => {
  const storesLengthByArea = {}
  for (const area in storesByArea) {
    if (storesByArea.hasOwnProperty(area)) {
      const stores = storesByArea[area]
      storesLengthByArea[area] = stores.length
    }
  }
  return storesLengthByArea
}

export const buildCategories = (dirtyTask: Task): CleanCategories => {
  const dirtyCategories: Categories = dirtyTask.categories
  const categoriesOrder: string[] = dirtyTask.categories_order
  const cleanCategories: CleanCategories = {}

  for (const categoryName of categoriesOrder) {
    const category: Category = dirtyCategories[categoryName]
    cleanCategories[categoryName] = category
  }
  return cleanCategories
}

const getTaskStatus = (isOpenedTask: boolean, subtasksKeys: string[], allSubtasks: SubTasks): number => {
  let subtasksStatusesCounter = { ...defaultTaskStatuses }
  let requiredSubtasksCounter = 0

  subtasksKeys.forEach((key: string) => {
    if (allSubtasks[key] && allSubtasks[key].is_st_required) {
      requiredSubtasksCounter++
      if (allSubtasks[key].type === keys.SUBTASK_TYPES.IMAGE_SUBTASK) {
        if (isNumber(allSubtasks[key].status) && allSubtasks[key].cover_img[0]) {
          subtasksStatusesCounter[keys.TASK_STATUSES.DONE.value] =
            subtasksStatusesCounter[keys.TASK_STATUSES.DONE.value] + 1
        }
      } else if (allSubtasks[key].type === keys.SUBTASK_TYPES.UPLOAD_FILE_SUBTASK) {
        if (isNumber(allSubtasks[key].status) && allSubtasks[key].files?.[0]) {
          subtasksStatusesCounter[keys.TASK_STATUSES.DONE.value] =
            subtasksStatusesCounter[keys.TASK_STATUSES.DONE.value] + 1
        }
      } else if (
        allSubtasks[key].type === keys.SUBTASK_TYPES.LINK_SUBTASK ||
        allSubtasks[key].type === keys.SUBTASK_TYPES.TEXT_SUBTASK
      ) {
        if (isNumber(allSubtasks[key].status)) {
          subtasksStatusesCounter[keys.TASK_STATUSES.DONE.value] =
            subtasksStatusesCounter[keys.TASK_STATUSES.DONE.value] + 1
        }
      } else if (allSubtasks[key].type === keys.SUBTASK_TYPES.PRODUCT_SUBTASK) {
        if (allSubtasks[key].cover_img?.[0] || isNumber(allSubtasks[key].status)) {
          subtasksStatusesCounter[keys.TASK_STATUSES.DONE.value] =
            subtasksStatusesCounter[keys.TASK_STATUSES.DONE.value] + 1
        }
      } else if (allSubtasks[key].type === keys.SUBTASK_TYPES.VIDEO_SUBTASKS) {
        if (allSubtasks[key].videos?.[0] || isNumber(allSubtasks[key].status)) {
          subtasksStatusesCounter[keys.TASK_STATUSES.DONE.value] =
            subtasksStatusesCounter[keys.TASK_STATUSES.DONE.value] + 1
        }
      }
    }
  })

  let taskStatus = isOpenedTask ? keys.TASK_STATUSES.INPROGRESS.value : keys.TASK_STATUSES.TODO.value
  if (isOpenedTask && subtasksStatusesCounter[keys.TASK_STATUSES.DONE.value] === requiredSubtasksCounter) {
    taskStatus = keys.TASK_STATUSES.DONE.value
  }

  return taskStatus
}

const countTasksByStatus: (tasks: CleanTask[]) => { [key: number]: number } = (tasks) =>
  tasks.reduce((acc, task) => {
    const status = task.taskStatus
    return { ...acc, [status]: (acc[status] || 0) + 1 }
  }, {})

const isTaskRoll = (task: CleanTask, subTasks: SubTasks) => {
  const subtasksIds = Object.values(task.categories).reduce<string[]>(
    (acc, category) => acc && category?.sub_tasks_order && [...acc, ...category.sub_tasks_order],
    []
  )
  return (
    task.roll && subtasksIds.some((subtasksIds) => subTasks[subtasksIds].type === keys.SUBTASK_TYPES.PRODUCT_SUBTASK)
  )
}

export const buildTasks = ({ groups_tasks, sub_tasks }: MainTasksData, taskViewIds: string[]) => {
  const isTask = keys.TASK_TYPE.TASK
  const isReportTask = keys.TASK_TYPE.REPORT
  const isExternalLink = keys.TASK_TYPE.EXTERNAL_LINK
  const buildedTasks: IBuildedTasks = {}
  const reportTasks: Task[] = []
  if (!groups_tasks) {
    return buildedTasks
  }

  groups_tasks.forEach((dirtyTask: Task) => {
    if ((dirtyTask.type === isTask || dirtyTask.type === isExternalLink) && dirtyTask.categories) {
      let currentSubtasks: string[] = []
      Object.keys(dirtyTask.categories).forEach((category: string) => {
        if (dirtyTask.categories[category]?.sub_tasks_order)
          currentSubtasks = [...currentSubtasks, ...dirtyTask.categories[category].sub_tasks_order]
      })

      const cleanTask: CleanTask = {
        ...dirtyTask,
        createdDateFormated: formatTimestamp(dirtyTask.created_at_ts, strings.DATE_FORMATS.outputs.taskPeriod, null),
        fromDateFormated: formatTimestamp(
          dirtyTask.from_ts,
          strings.DATE_FORMATS.outputs.taskPeriod,
          strings.DATE_FORMATS.inputs.taskPeriod
        ),
        toDateFormated: formatTimestamp(
          dirtyTask.deadline || dirtyTask.to_ts,
          strings.DATE_FORMATS.outputs.taskPeriod,
          strings.DATE_FORMATS.inputs.taskPeriod
        ),
        taskStatus: getTaskStatus(dirtyTask.is_opened, currentSubtasks, sub_tasks),
      }
      if (dirtyTask.type === isTask) {
        cleanTask.categories = buildCategories(dirtyTask)
      }
      const taskView = dirtyTask.view.toString()
      const validTaskView = taskViewIds.includes(taskView) ? taskView : OTHER_TASK_VIEW_ID
      const updatedTasks = [...(buildedTasks[validTaskView]?.tasks || []), cleanTask]
      buildedTasks[validTaskView] = {
        tasks: updatedTasks,
        statuses: { ...defaultTaskStatuses, ...countTasksByStatus(updatedTasks) },
      }
    } else if (dirtyTask.type === isReportTask) {
      reportTasks.push(dirtyTask)
    }
  })

  const rollTasks = Object.values(buildedTasks).reduce<CleanTask[]>((acc, taskObj) => {
    const filteredTasks = taskObj.tasks.filter((task) => isTaskRoll(task, sub_tasks))
    return [...acc, ...filteredTasks]
  }, [])

  return { allTasks: buildedTasks, reportTasks, rollTasks }
}

export function formatTimestamp(
  input: string | number,
  outputFormat: any,
  inputFormat?: any,
  is_calculate_utc_offset: boolean = true
) {
  /**
   * @param {string | number} input in epoc style i.e. 12345953334
   * @param outputFormatString  format fot moment to return
   */
  if (typeof input === 'number') {
    return dayjs.unix(input).format(outputFormat).toString()
  } else {
    if (is_calculate_utc_offset) {
      const currentLocale = dayjs.tz.guess()
      return dayjs.utc(input, inputFormat).tz(currentLocale).format(outputFormat)
    }
    return dayjs(input, inputFormat).format(outputFormat)
  }
}

export const downloadZip = async (files: IFileDownload[]) => {
  return new Promise(async (resolve, reject) => {
    const EXTENSIONS_TO_REPLACE = ['.jpg', '.jpeg']
    const zip = new JSZip()
    let errorFiles = 0
    for (let file in files) {
      try {
        const downloadUrl = files[file].downloadUrl
        let imageFileUrlExtensionToReplace = ''
        for (let sepInd in EXTENSIONS_TO_REPLACE) {
          const separator = EXTENSIONS_TO_REPLACE[sepInd]
          if (downloadUrl.indexOf(separator) !== -1) {
            imageFileUrlExtensionToReplace = separator
          }
        }
        const imageUrl = downloadUrl.replace(
          imageFileUrlExtensionToReplace,
          imageFileUrlExtensionToReplace + '?cache_baster=' + getCurrentEpoch().toString()
        )
        const res: any = await fetch(imageUrl, {
          method: 'GET',
          headers: {
            Accept: 'image/avif,image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8',
            // 'sec-fetch-dest': 'image'
          },
        })
        const arrayBuffer = await res.arrayBuffer()
        await zip.file(files[file].name + files[file].extension, arrayBuffer, { binary: true })
      } catch (error) {
        errorFiles++
        console.log(`Something went wrong with loading image for ${files[file].name}: ${error}`)
      }
    }

    if (errorFiles !== files.length) {
      zip.generateAsync({ type: 'blob' }).then(
        function (blob) {
          saveAs(blob, 'images_exported_files_' + getCurrentEpoch().toString() + '.zip')
        },
        function (err) {
          console.log(err)
        }
      )
      resolve(true)
    } else {
      reject()
    }
  })
}

export const downloadZipV2 = async (files: IFileDownload[]) => {
  const EXTENSIONS_TO_REPLACE = ['.jpg', '.jpeg']
  const zip = new JSZip()
  let errorFiles = 0
  const fileNames = new Set<string>()

  await Promise.all(
    files.map(async (file) => {
      try {
        let downloadUrl = file.downloadUrl

        EXTENSIONS_TO_REPLACE.forEach((ext) => {
          if (downloadUrl.includes(ext)) {
            downloadUrl = downloadUrl.replace(ext, ext + `?cache_baster=${getCurrentEpoch().toString()}`)
          }
        })

        const response = await fetch(downloadUrl, {
          method: 'GET',
          headers: {
            Accept: 'image/avif,image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8',
          },
        })

        if (!response.ok) {
          throw new Error(`Failed to fetch ${downloadUrl} - ${response.statusText}`)
        }

        const arrayBuffer = await response.arrayBuffer()
        let counter = 1
        let fileName = `\u200E${file.name} (${counter})${file.extension}`

        while (fileNames.has(fileName)) {
          fileName = `\u200E${file.name} (${counter + 1})${file.extension}`
          counter++
        }
        fileNames.add(fileName)

        zip.file(fileName, arrayBuffer, { binary: true })
      } catch (error) {
        errorFiles++
        console.error(`Error downloading file: ${file.downloadUrl}`, error)
      }
    })
  )

  if (errorFiles < files.length) {
    try {
      const blob = await zip.generateAsync({ type: 'blob' })
      saveAs(blob, `media_files_${Date.now()}.zip`)
      console.log('Download completed successfully!')
    } catch (err) {
      console.error('Failed to generate ZIP:', err)
    }
  } else {
    console.error('All files failed to download')
  }
}

export const fetchedStoresState = ({ storesByAreaToFetch, sid, area, fetchedStores }: any) => {
  const sidArray = sid
  const nextStoresToFetch = storesByAreaToFetch[area]
    ? storesByAreaToFetch[area].filter((store: any) => !sidArray.includes(store))
    : []

  const nextStores = storesByAreaToFetch

  if (!nextStoresToFetch.length) {
    delete nextStores[area]
  } else {
    nextStores[area] = nextStoresToFetch
  }

  let nextCurrentFetchedStores
  if (fetchedStores && fetchedStores[area]) {
    nextCurrentFetchedStores = [...fetchedStores[area], ...sidArray]
  } else {
    nextCurrentFetchedStores = [...sidArray]
  }

  return {
    nextStoresToFetch: JSON.parse(JSON.stringify(nextStores)),
    currentStores: JSON.parse(
      JSON.stringify({
        ...fetchedStores,
        [area]: nextCurrentFetchedStores,
      })
    ),
  }
}

export function getUrlParam(value: string) {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(value)
}

export const handleErrorWithCallback = (
  status: number,
  callbackDelay: number,
  callback: (...args: any) => any,
  ...callbackArgs: any
): any => {
  if (status === 502) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(callback(...callbackArgs))
      }, callbackDelay)
    })
  } else {
    return () => {}
  }
}

export const deleteAllCookies = () => {
  const cookies = document.cookie.split(';')
  cookies.forEach((cookie) => {
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`
  })
}

export const handleError = async (status: number, callback?: () => void) => {
  if (status === 401) {
    deleteAllCookies()
    if (callback) {
      callback()
    }
  }
}

export const filterObject = (obj: any, predicate: any) => {
  return Object.keys(obj)
    .filter((key) => {
      return predicate(obj[key])
    })
    .reduce((res, key) => ((res[key] = obj[key]), res), {})
}

export const getFileName = (fullPath: string) => {
  return fullPath?.split('\\')?.pop()?.split('/').pop() || 'filename'
}

export const extractFileName = (url: string): string => {
  const parts = url.split('/')

  const lastSegment = parts.pop() || ''

  const underscoreIndex = lastSegment.indexOf('_')

  if (underscoreIndex === -1) {
    return lastSegment
  }

  const afterUnderscore = lastSegment.substring(underscoreIndex + 1)

  const hyphenIndex = afterUnderscore.indexOf('-')

  if (hyphenIndex === -1) {
    return afterUnderscore
  }

  return afterUnderscore.substring(hyphenIndex + 1)
}

export const getStatusColor = (status: number) => {
  const statusKey = status % keys.STATUS_COLORS_LENGTH
  let statusBGColor = status !== null ? keys.STATUS_COLORS[statusKey] : 'white'
  let statusColor = status !== null ? keys.STATUS_COLORS[statusKey] : 'black'
  return { statusBGColor, statusColor }
}

export const isCoverImageValid = (coverImage: (string | null)[]) => {
  return isSolid(coverImage) && coverImage[0] !== null
}

export const getLiteral = (literals: { [key: string]: string }, literalKey: string) => {
  if (literals) {
    return literals[literalKey] ? literals[literalKey] : ''
  }

  return ''
}

export const getCurrentEpoch = () => dayjs().unix()

export const getGroupsMaxLevel = (groups: { [key: string]: IConfigGroup }): number => {
  let maxLevel = 0
  Object.keys(groups).forEach((key: string) => {
    if (groups[key].level > maxLevel) maxLevel = groups[key].level
  })

  return maxLevel
}

export const getCurrentActiveGroupIdByMaxLevel = (groups: { [key: string]: IConfigGroup }): string => {
  let currentActiveGroupID = Object.keys(groups)?.[0]
  Object.keys(groups).forEach((groupKey: string) => {
    if (groups[groupKey].level > groups[currentActiveGroupID].level) {
      currentActiveGroupID = groupKey
    }
  })

  return currentActiveGroupID
}

export const convertEpocTimeStampToDate = (createdAT: number, format: string = keys.READABLE_DATE_FORMAT) =>
  dayjs.unix(createdAT).format(format)

export const isPostLinkedToCurrentStoreTask = (tasks: any[], refID: string) => {
  if (!isSolid(tasks)) return
  let taskObjectByRefID = undefined
  taskObjectByRefID = tasks.find((item: any) => item.ref_id === refID)

  return isSolid(taskObjectByRefID)
}

export const taskObjectLinkedToPost = (tasks: any[], refID: string) => {
  if (!isSolid(tasks)) return
  let taskObjectByRefID = undefined
  taskObjectByRefID = tasks.find((item: any) => item.ref_id === refID)

  return taskObjectByRefID
}

export function addOrRemove(array: any[], value: any) {
  var index = array.indexOf(value)

  if (index === -1) {
    array.push(value)
  } else {
    array.splice(index, 1)
  }

  return array
}

export const sumObjectValues = (obj: object) => Object.values(obj).reduce((a, b) => a + b)

export const getTimestampAsString = (
  date = new Date(),
  outputFormat: string = keys.DEFAULT_STRING_FORMAT_TIMESTAMP,
  timezone?: string
) => {
  let currentDate = dayjs(date)
  if (timezone) {
    currentDate = currentDate.tz(timezone, true).utc()
  } else {
    currentDate = currentDate.utc()
  }
  return currentDate.format(outputFormat)
}

export const dateTimeToPercentageDone = (from: any, to: any) => {
  const current: any = getTimestampAsString()
  const result = ((current - from) / (to - from)) * 100
  return result
}

export const filterBySID = (sid: string) => (task: CleanTask) => task.rs_id.split('-')?.[1] === sid

export const filterByCategoryName = (categoryName: string) => (task: CleanTask) => {
  return task.categories_order && task.categories_order.includes(categoryName)
}

export const decomposeRetailGroupId = (rsid: string) => {
  return rsid.split(/-(.+)/)[1]
}

export const filteredTaskByArea = (tasks: any, storeKey: any, title: string) =>
  // eslint-disable-next-line array-callback-return
  tasks.find((task: any) => {
    const rsID = decomposeRetailGroupId(task?.rs_id)
    if (rsID == storeKey && title === task.title) {
      return task
    }
  })

export const isRTL = (text: string) => {
  const ltrChars =
    'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF' +
    '\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF'
  const rtlChars = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC'
  // eslint-disable-next-line no-misleading-character-class
  const rtlDirCheck = new RegExp('^[^' + ltrChars + ']*[' + rtlChars + ']')

  return rtlDirCheck.test(text)
}

export const generateID = () => Math.random().toString(36).substr(2, 9)

export const generateArrayForCommentsSkeleton = (commentsCounter: number, offset: number, limit: number) => {
  let total = limit + offset // 7
  if (total > commentsCounter) {
    let remainder = commentsCounter - offset
    total = remainder + offset
  }
  return Array.from(Array(total).keys())
}

export const sortGroupsObject = (obj: any) => {
  return Object.assign(
    Object.values(obj).sort(function (a: any, b: any) {
      return b.level - a.level
    })
  )
}

export const debounce = (func: any, wait: number) => {
  let timerId: any = undefined
  return (...args: any) => {
    clearTimeout(timerId)
    timerId = setTimeout(() => {
      func(...args)
    }, wait)
  }
}

export const generateUniqueName = (names: any[], providedName?: string) => {
  let defaultName = 'default_name'
  if (names.includes(defaultName) || names.includes(providedName)) {
    return defaultName + 1
  } else {
    return defaultName
  }
}

export const getUrlParamsString = (paramsObj: object) => {
  const params = new URLSearchParams()

  for (const param in paramsObj) {
    if (isSolid(paramsObj[param])) params.append(param, paramsObj[param])
  }

  return '&' + params.toString()
}

export const checkValidation = (value: any, validationRules: IValidationRules) => {
  let isValid = true

  if (!validationRules.isRequired) {
    return isValid
  }

  if (validationRules.isNumber) {
    isValid = typeof value === 'number' && isValid
  }

  if (validationRules.minLength) {
    isValid = value.length >= validationRules.minLength && isValid
  }

  if (validationRules.maxLength) {
    isValid = value.length <= validationRules.maxLength && isValid
  }

  return isValid
}
export const calcReportPercentage = (value: number, goal: number): number => {
  let percentage = (value / goal) * 100 - 100
  if (isNaN(percentage)) {
    percentage = 0
  }
  if (percentage === Infinity) {
    percentage = value === 0 ? 0 : 100
  }

  return percentage
}

export const customToFixed = (number: number, countAfterDot: number = 2): string => {
  return number.toFixed(countAfterDot).replace(/[.,]00$/, '')
}

export const getOverviewAnalytical = (
  statuses: { [key: number]: number },
  totalCounter: number
): ITaskOverviewAnalytic[] => {
  // Import COMPLETION_STATUS_COLORS dynamically to avoid circular dependency
  const COMPLETION_STATUS_COLORS = {
    done: '#8cc0ff',
    inProgress: '#FFF2CC',
    todo: '#dfdfdf',
    approved: '#CBEAC1',
    rejected: '#fc9f9f',
  }

  const todoCount = statuses[keys.TASK_STATUSES.TODO.value] || 0
  const inprogressCount = statuses[keys.TASK_STATUSES.INPROGRESS.value] || 0
  const doneCount = statuses[keys.TASK_STATUSES.DONE.value] || 0
  const disapprovedCount = statuses[keys.TASK_STATUSES.DISAPPROVED.value] || 0
  const approvedCount = statuses[keys.TASK_STATUSES.APPROVED.value] || 0

  const todoPercent = totalCounter > 0 ? (todoCount / totalCounter) * 100 : 0
  const inprogressPercent = totalCounter > 0 ? (inprogressCount / totalCounter) * 100 : 0
  const donePercent = totalCounter > 0 ? (doneCount / totalCounter) * 100 : 0
  const disapprovedPercent = totalCounter > 0 ? (disapprovedCount / totalCounter) * 100 : 0
  const approvedPercent = totalCounter > 0 ? (approvedCount / totalCounter) * 100 : 0

  const analytic = [
    {
      name: 'analytical_done',
      value: Math.round(donePercent),
      color: COMPLETION_STATUS_COLORS.done,
    },
    {
      name: 'analytical_approved',
      value: Math.round(approvedPercent),
      color: COMPLETION_STATUS_COLORS.approved,
    },
    {
      name: 'analytical_rejected',
      value: Math.round(disapprovedPercent),
      color: COMPLETION_STATUS_COLORS.rejected,
    },
    {
      name: 'analytical_inprogress',
      value: Math.round(inprogressPercent),
      color: COMPLETION_STATUS_COLORS.inProgress,
    },
    {
      name: 'analytical_todo',
      value: Math.round(todoPercent),
      color: COMPLETION_STATUS_COLORS.todo,
    },
  ]
  return analytic
}

export const getDoneRation = (statuses: { [key: number]: number }, totalCounter: number): number => {
  let doneRation = 0

  // Done Ratio  = done_tasks/total_number_of_tasks ration
  if (statuses[keys.TASK_STATUSES.DONE.value]) {
    doneRation = statuses[keys.TASK_STATUSES.DONE.value] / totalCounter
  }

  // options 2 : done ration  = done_tasks/total_number_of_tasks ration  + inprogress_tasks/2*total_number_of_tasks ration
  if (statuses[keys.TASK_STATUSES.INPROGRESS.value]) {
    doneRation += statuses[keys.TASK_STATUSES.INPROGRESS.value] / (2 * totalCounter)
  }

  //  * 100 === value in percents
  doneRation *= 100
  return +doneRation.toFixed(2)
}

export const generateInitialGroups = (
  allGroups: IAllUserTaskPermittedGroup,
  initialChecked: boolean = true,
  isAddParent: boolean = false
) => {
  let variants: IGroupCheckbox[] = []
  for (let key of Object.keys(allGroups)) {
    if (allGroups[key]) {
      if (allGroups[key].level === 2) {
        const parentVariantIdx = variants.findIndex((item) => item.value === key)
        if (parentVariantIdx < 0) {
          const parentId = allGroups[key].parent
          const childs: ICheckbox[] = []

          if (isAddParent) {
            childs.push({
              isHide: false,
              title: allGroups[key].name,
              isChecked: initialChecked,
              value: key,
            })
          }

          const variant: IGroupCheckbox = {
            title: allGroups[key].name,
            isChecked: initialChecked,
            child: childs,
            choosedChilds: [],
            value: key,
            level: 2,
            parentId: parentId || '',
            retailId: parentId ? allGroups[parentId]?.parent : '',
            isAllChecked: initialChecked,
          }
          variants.push(variant)
        }
      } else if (allGroups[key].level === 1) {
        const parentVariantIdx = variants.findIndex((item) => item.value === allGroups[key].parent)

        const childVariant = {
          title: allGroups[key].name,
          isChecked: initialChecked,
          value: key,
          level: 1,
        }

        if (parentVariantIdx >= 0) {
          variants[parentVariantIdx].child.push(childVariant)
          if (initialChecked) {
            variants[parentVariantIdx].choosedChilds = [...variants[parentVariantIdx].choosedChilds!, key]
          }
        } else {
          const parentKey = allGroups[key].parent
          const childs: ICheckbox[] = []

          if (isAddParent && allGroups[parentKey]) {
            childs.push({
              title: allGroups[parentKey].name,
              isChecked: initialChecked,
              value: parentKey,
            })
          }
          childs.push(childVariant)
          const variant: IGroupCheckbox = {
            title: allGroups[parentKey] ? allGroups[parentKey].name : '',
            isChecked: initialChecked,
            child: childs,
            choosedChilds: initialChecked ? [key] : [],
            value: parentKey,
            level: 2,
            isAllChecked: initialChecked,
          }
          variants.push(variant)
        }
      }
    }
  }

  return variants.map((variant) => {
    return {
      ...variant,
      countChilds: variant.child.length,
    }
  })
}

export const getTranslationsKeys = (translations: object) => {
  const supportedLanguages = ['en', 'he', 'es', 'tr', 'pt-BR', 'ru', 'pt', 'it']
  const langKeys = Object.keys(translations).filter((key: string) => supportedLanguages.includes(key))

  return langKeys
}

export const getDeviceType = (): DEVICE_TYPES_ENUM => {
  const userAgent = navigator.userAgent
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) {
    return DEVICE_TYPES_ENUM.TABLET
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      userAgent
    )
  ) {
    return DEVICE_TYPES_ENUM.MOBILE
  }
  return DEVICE_TYPES_ENUM.DESKTOP
}

export const cropText = (str: string, maxLength: number) =>
  str.length > maxLength ? `${str.slice(0, maxLength)}...` : str

export const checkIsAdmin = (userName: string) => userName.includes('admin')

export const kebabCaseToCamelCase = (str: string) => str.replace(/-./g, (x) => x.toUpperCase()[1])

export const pathNameToRouteName = (path: string) => kebabCaseToCamelCase(path).replace('/', '')

export const spreadOutOfDate = (date?: Date) => {
  const currentDate = date ? new Date(date) : new Date()
  return {
    fullYear: currentDate.getFullYear(),
    month: currentDate.getMonth(),
    day: currentDate.getDay(),
    date: currentDate.getDate(),
    hours: currentDate.getHours(),
    minutes: currentDate.getMinutes(),
    seconds: currentDate.getSeconds(),
  }
}
export const getAllCookies = (): { [key: string]: string } => {
  const cookies = {}
  document.cookie.split(';').forEach((cookie) => {
    const [key, value] = cookie.split('=')
    cookies[key] = value
  })
  return cookies
}

export const getTokenFromCookie = (): string | undefined => {
  const cookies = getAllCookies()
  const tokenKey = Object.keys(cookies).filter((cookieKey) => cookieKey.includes('token'))[0]
  return cookies[tokenKey]
}

export const setCookie = (key: string, value: string): void => {
  document.cookie = `${key}=${value}; path=/;`
}

export const refactorPartOfTime = (time: number) => (time < 10 ? `0${time}` : time)

export const getFileExtension = (fileName: string) => fileName?.split('.').pop() || ''

export const getFileNameWithoutExtension = (fileName: string) => fileName.split('.').shift()

export const isTaskDone = (subTaskIds: string[], subTasks: SubTasks) => {
  if (subTaskIds)
    for (const stId of subTaskIds) {
      const subTask = subTasks[stId]
      if (!subTask) return
      if (subTask.is_st_required) {
        if (subTask.status === null) {
          return false
        }
      }
    }
  return true
}

export const extractFileNameFromS3Link = (fileUrl: string) =>
  fileUrl.split('/').pop()?.split('_').slice(1).join('_').split('-').splice(1).join('-')

export const getStatusOfStore = (statuses?: { [key: number]: number }) => {
  if (statuses) {
    if (statuses[keys.TASK_STATUSES.DONE.value]) {
      return { status: keys.TASK_STATUSES.DONE.value, color: colors.analyticGreen }
    } else if (statuses[keys.TASK_STATUSES.INPROGRESS.value]) {
      return { status: keys.TASK_STATUSES.INPROGRESS.value, color: colors.analyticYellow }
    }
  }
  return { status: keys.TASK_STATUSES.TODO.value, color: colors.analyticGrey }
}

// Wraps Office documents (doc/xls/ppt…) in the Microsoft Office web viewer so they open in the browser
// instead of downloading; everything else is returned untouched. Pass `fileNameForExt` when `fileUrl` is a
// presigned/opaque URL whose extension can't be read from the path (the viewer still fetches `fileUrl`).
export const openInCloudViewer = (fileUrl: string, fileNameForExt?: string): string => {
  const fileExtension = getFileExtension(fileNameForExt || fileUrl).toLowerCase()

  if (fileExtension && keys.extensionsForCloudViewer.includes(fileExtension)) {
    return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(fileUrl)}`
  }
  return fileUrl
}

export const getAudioDuration = (url: string, callback: (dur: number) => void) => {
  const player = new Audio(url)
  player.addEventListener(
    'durationchange',
    function () {
      if (this.duration !== Infinity) {
        const duration = this.duration
        player.remove()
        callback(duration)
      }
    },
    false
  )
  player.load()
  player.currentTime = 24 * 60 * 60 //fake big time
}

export const convertDateReportStringToDate = (date: string) => {
  const dateArray = date.split('/')
  return new Date(+dateArray[2], +dateArray[1] - 1, +dateArray[0])
}

export const reportTitleToStartAndEndDate = (reportTitle: string) => {
  const dateArray = reportTitle.split('-')
  const dateArrayLength = dateArray.length
  const startDateString = dateArray[dateArrayLength - 2]
  const endDateString = dateArray[dateArrayLength - 1]
  return {
    startDateString,
    endDateString,
  }
}

export const isReportEnabled = (reportTitle: string, startDateOfRange?: Date | null, endDateOfRange?: Date | null) => {
  const { endDateString } = reportTitleToStartAndEndDate(reportTitle)
  if (startDateOfRange && endDateOfRange) {
    const endDate = convertDateReportStringToDate(endDateString)
    return (
      ((isAfter(endDate, startDateOfRange) || isEqual(endDate, startDateOfRange)) &&
        isBefore(endDate, endDateOfRange)) ||
      isEqual(endDate, endDateOfRange)
    )
  }
  return true
}

export const deploySignature = `${process.env.REACT_APP_DEPLOY_SIGNATURE}`

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const getPercentageDifference = (prevValue: number, currentValue: number) =>
  !prevValue ? 0 : (currentValue / prevValue - 1) * 100

export const getSubtasks = (subTasksOrder: string[], subtkasks: SubTasks) => {
  return subTasksOrder?.reduce<SubTask[]>((acc, sabtaskId) => {
    const subtask = subtkasks[sabtaskId]
    if (subtask) {
      acc.push(subtask)
    }
    return acc
  }, [])
}

export const secondsToFormatedTime = (seconds?: number) => {
  if (!seconds) return '0:00'
  const helperDate = addSeconds(new Date(0), seconds)
  return format(helperDate, 'm:ss')
}

export const getRgId = (retailId: string, groupId: string) => `${retailId}-${groupId}`

export const populateUrl = (url: string, parameters: { [key: string]: string }) => {
  for (let key in parameters) {
    url = url.replaceAll(key, parameters[key])
  }
  return url
}

export const sortTasks = <T extends { from_ts?: string; created_at_ts?: number; priority?: number | null }>(
  tasks: T[],
  sortingMode = TASK_SORTING.STARTING_DATE.toString()
) => {
  const parseTimestamp = (timestamp?: string) => {
    if (!timestamp) return null

    return dayjs(timestamp, ['YYYY-MM-DD HH:mm:ss', 'YYYYMMDDHHmmss'], true).isValid()
      ? dayjs(timestamp, ['YYYY-MM-DD HH:mm:ss', 'YYYYMMDDHHmmss']).valueOf()
      : null
  }

  const getTaskTimestamp = (task: T) => parseTimestamp(task.from_ts) ?? task.created_at_ts ?? 0

  if (sortingMode === TASK_SORTING.STARTING_DATE.toString()) {
    return tasks.sort((task, nextTask) => {
      const taskTimestamp = getTaskTimestamp(task)
      const nextTaskTimestamp = getTaskTimestamp(nextTask)

      return nextTaskTimestamp - taskTimestamp
    })
  } else if (sortingMode === TASK_SORTING.PRIORITY.toString()) {
    return tasks.sort((task, nextTask) => {
      // Priority sorting: 3 (high) -> 2 (medium) -> 1 (low) -> null/undefined (none)
      const taskPriority = task.priority ?? 0 // null/undefined becomes 0 (lowest priority)
      const nextTaskPriority = nextTask.priority ?? 0

      // If priorities are different, sort by priority (high to low)
      if (taskPriority !== nextTaskPriority) {
        return nextTaskPriority - taskPriority
      }

      // If priorities are the same, sort by date (newest first)
      const taskTimestamp = getTaskTimestamp(task)
      const nextTaskTimestamp = getTaskTimestamp(nextTask)

      return nextTaskTimestamp - taskTimestamp
    })
  } else {
    return [...tasks]
  }
}

export const joinTasksViews = (tasks: IAllTasks) => {
  return Object.values(tasks).reduce<CleanTask[]>((acc, el) => [...acc, ...el?.tasks], [])
}

export const filterNotificationTasks = (tasks: CleanTask[], subTasks: SubTasks, lengthOfTasksList: number) =>
  tasks
    .filter((task) => {
      const allSubtask = Object.values(task.categories).reduce(
        (acc: string[], category) => acc && category?.sub_tasks_order && [...acc, ...category.sub_tasks_order],
        []
      )
      return !isTaskDone(allSubtask, subTasks)
    })
    .slice(0, lengthOfTasksList)

export const sortStoresByDiff = (reports: IRankingReport[], mode: Sorting) => {
  return reports.sort((report, nextReport) => {
    if (report.diff === nextReport.diff) {
      return 0
    } else if (report.diff === null) {
      return 1
    } else if (nextReport.diff === null) {
      return -1
    }
    return mode === 'asc' ? report.diff - nextReport.diff : nextReport.diff - report.diff
  })
}

export const sortStoresByRank = (reports: IRankingReport[], mode: Sorting) => {
  return reports
    .filter((report) => report.rank !== null)
    .sort((store, nextStore) => {
      if (mode === 'desc') {
        return nextStore.rank - store.rank || store.name.localeCompare(nextStore.name)
      } else {
        return store.rank - nextStore.rank || store.name.localeCompare(nextStore.name)
      }
    })
}

export const getArea = (ids: string[], groups: IConfigStateGroups) => {
  let arr: string[] = ids
  ids.forEach((id) => {
    const children = groups[id]?.child?.filter((id) => groups[id]?.child?.length)
    if (children.length) {
      arr = [...arr, ...getArea(children, groups)]
    }
  })
  return arr
}

export const getStores = (ids: string[], groups: IConfigStateGroups) => {
  const areas = getArea(ids, groups)
  return areas.map((area) => groups[area].child).flat(Infinity)
}

export const resetSecondsAndMS = (date: Date) => {
  const seconds = date.getSeconds()
  const mSeconds = date.getMilliseconds()
  return subMilliseconds(sub(date, { seconds }), mSeconds)
}

export const integrationAction = (method: string, options: { uid?: string; url?: string; lang?: string }) => {
  const appendLang = (url: string) =>
    options.lang ? `${url}${url.includes('?') ? '&' : '?'}lang=${encodeURIComponent(options.lang)}` : url

  switch (method) {
    case INTEGRATION_TYPE.EZ_TIME:
      if (options.url && options.uid) {
        const populatedUrl = populateUrl(options.url, { '{uid}': options.uid })
        window.open(appendLang(populatedUrl), '_blank')
      }
      break
    case INTEGRATION_TYPE.STOCK:
      if (options.url && options.uid) {
        const token = getTokenFromCookie()
        const populatedUrl = populateUrl(options.url, { '{token}': token || '' })
        window.open(appendLang(populatedUrl), '_blank')
      }

      break
  }
}

export const getCapsuleCalculation = ({
  leftOperand,
  rightOperand,
  createdAt,
  newValue,
}: {
  leftOperand: number
  rightOperand: number
  createdAt: number
  newValue?: number
}) => {
  return { capsuleValue: newValue || leftOperand, isNewCalculation: true }
}

export const getCapsuleColor = (value: number, goal: number) => {
  if (!value) return 'transparent'
  return value <= goal ? colors.tomato : colors.greenDark
}

export const validObjectStructure = (obj: object, keys: string[]) => {
  const objKeys = Object.keys(obj)
  return keys.every((key) => objKeys.includes(key))
}

export const getFormattedNumber = (value: number) => formatter.format(+value?.toFixed(2))

export const initialDate = { from_ts: getUnixTime(sub(new Date(), { days: 90 })), to_ts: getUnixTime(new Date()) }

export const stringTsToDate = (value: string): Date => {
  const dateParts = value.split('/')
  const year = parseInt(dateParts[2], 10)
  const month = parseInt(dateParts[1], 10) - 1
  const day = parseInt(dateParts[0], 10)
  return new Date(year, month, day)
}
const replaceEmptyStringWithNull = (obj: any) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] === '') {
        obj[key] = null
      }
    }
  }
}
export const getDifferenceOfObjects = (obj1: any, obj2: any, exceptions: string[]) => {
  const differentValues = {}
  for (const key in obj1) {
    if (exceptions.includes(key)) differentValues[key] = obj1[key]
    if (
      (!obj2?.hasOwnProperty(key) && obj1[key] !== '') ||
      (obj2?.hasOwnProperty(key) && obj2[key] !== null && obj1[key] !== obj2[key]) ||
      (obj2?.hasOwnProperty(key) && obj2[key] === null && obj1[key] !== null && obj1[key] !== '')
    ) {
      differentValues[key] = obj1[key]
    }
  }
  replaceEmptyStringWithNull(differentValues)

  return differentValues
}

export const generatePassword = (): string => {
  const regexPattern = /^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[!@#$%^&*+.]){1,}).{8,26}$/
  const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*+.'
  const passwordLength = Math.floor(Math.random() * (26 - 8 + 1)) + 8

  let password = ''
  while (!password.match(regexPattern)) {
    password = ''
    for (let i = 0; i < passwordLength; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length)
      password += characters.charAt(randomIndex)
    }
  }
  return password
}
export const findArrayDifference = (arr1: string[], arr2: string[]) => {
  const diff1 = arr1?.filter((item) => !arr2?.includes(item))
  const diff2 = arr2?.filter((item) => !arr1?.includes(item))
  const difference = diff1.concat(diff2)

  return difference
}

export const roundPercentage = (number: string) => {
  const roundedValue = parseFloat(number).toFixed(2)

  return roundedValue
}

export function mergeArrays(firstArray: any[], secondArray: any[]) {
  const mergedArray = []

  for (let i = 0; i < secondArray.length; i++) {
    const element = secondArray[i]
    let found = false

    for (let j = 0; j < firstArray.length; j++) {
      const item = firstArray[j]

      if (item.sk === element) {
        mergedArray.push(item)
        found = true
        break
      }
    }

    if (!found) {
      mergedArray.push(element)
    }
  }

  return mergedArray
}
export const isValidNumberString = (str: string): boolean => {
  const numberRegex = /^\d+$/
  const specialCharsRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?€£¥¢₽¥₩₺₹₿฿₫₴₱₸₪]/

  if (specialCharsRegex.test(str)) {
    return false
  }
  if (!numberRegex.test(str)) {
    return false
  }

  return true
}

export const isWord = (input: string): boolean => {
  const trimmedInput = input.trim()
  const isOnlyLetters = /^[\p{L}]+$/u.test(trimmedInput)

  return isOnlyLetters
}

export const wasBrowserRefreshed = () => {
  return !!sessionStorage.getItem('wasRefreshed')
}
export const isCurrencySymbol = (input: string): boolean => {
  const currencySymbols = /^[\p{Sc}]+$/u
  return currencySymbols.test(input)
}

export const updateLocalStorageItem = <T>(name: string, data: T): boolean => {
  try {
    const existingData: T = JSON.parse(localStorage.getItem(name) as string)
    if (existingData) {
      const updatedData: T = { ...existingData, ...data }
      localStorage.setItem(name, JSON.stringify(updatedData))
    } else {
      localStorage.setItem(name, JSON.stringify(data))
    }
    return true
  } catch (error) {
    console.error('Error updating data in local storage:', error)
    return false
  }
}

export const getLocalStorageItem = <T>(name: string): T | null => {
  try {
    const data: T | null = JSON.parse(localStorage.getItem(name) as string)
    return data
  } catch (error) {
    console.error('Error retrieving data from local storage:', error)
    return null
  }
}

export const checkKeyExists = (obj: any, key: string) => {
  return Object.prototype.hasOwnProperty.call(obj, key)
}

export function trimAndCountExtraGroups({ items, sliceLimit }: { items: string; sliceLimit: number }): string {
  const splittedItems = items.split(',')
  if (splittedItems.length > sliceLimit) {
    const trimmedGroupsString = splittedItems.slice(0, sliceLimit).join(', ')
    const remainingCount = splittedItems.length - sliceLimit
    return `${trimmedGroupsString} + ${remainingCount}`
  }
  return items
}

export const getTextDirection = (text: string): 'rtl' | 'ltr' => {
  const rtlPattern = /[\u0590-\u05FF\u0600-\u06FF]/
  return rtlPattern.test(text) ? 'rtl' : 'ltr'
}

export const timastampStringToDate = (dateString: string) => {
  const formattedDateString = `${dateString.substring(0, 4)}-${dateString.substring(4, 6)}-${dateString.substring(
    6,
    8
  )}T${dateString.substring(8, 10)}:${dateString.substring(10, 12)}:${dateString.substring(12, 14)}.000Z`
  return dayjs(formattedDateString).toDate()
}

export const filterTasksByRelatedId = (obj: any, objKey: string, id: string) => {
  const filteredObj = {}

  for (const key in obj) {
    if (obj[key][objKey] === id) {
      filteredObj[key] = obj[key]
    }
  }

  return filteredObj
}

export const isValidDomain = (url: string): boolean => {
  try {
    const domainPattern = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/
    const domain = new URL(url).hostname
    return domainPattern.test(domain)
  } catch (e) {
    console.error(e)
    return false
  }
}
export const calculateUserActivity = (users: string[] | undefined, activity: { [key: string]: boolean }) => {
  if (!users || !activity) {
    return {}
  }

  return users.reduce((acc, user) => {
    acc[user] = !!activity[user]
    return acc
  }, {})
}

const shiftChar = (char: string, shift = 3) => {
  return String.fromCharCode((char.charCodeAt(0) + shift) % 256)
}
export const encode = (string: string, shift = 3) => {
  const slicedString = string.slice(-5)
  let encoded = ''
  for (let i = 0; i < slicedString.length; i++) {
    encoded += shiftChar(slicedString[i], shift)
  }
  return encoded
}
export const decode = (encodecString: string, shift = 3) => {
  let decoded = ''
  for (let i = 0; i < encodecString.length; i++) {
    if (i < encodecString.length - 5) {
      decoded += encodecString[i]
    } else {
      decoded += shiftChar(encodecString[i], -shift)
    }
  }
  return decoded
}
export function extractSubstringAfterDelimiter(fullString: string, delimiter: string): string {
  const ridIndex = fullString.indexOf(delimiter)
  if (ridIndex === -1) {
    return ''
  }

  return fullString.substring(ridIndex + delimiter.length + 1)
}

export const extractedUidsFromGroups = (groupsArray: string[], groupsObject: IConfigStateGroups) => {
  return groupsArray.flatMap((groupId) => groupsObject[groupId]?.uids)
}

export const findGroupByUid = (
  groupsArray: string[],
  groupsObject: IConfigStateGroups,
  uid: string
): string | undefined => {
  return groupsArray.find((groupId) => groupsObject[groupId]?.uids?.includes(uid))
}

export const findTagByUid = (tags: ITag[], groupsObject: IConfigStateGroups, uid: string): string | undefined => {
  return tags.find(
    (tag) => tag?.users?.includes(uid) || (tag?.groups && findGroupByUid(tag.groups, groupsObject, uid) !== undefined)
  )?.sk
}

export const parseDateTimeString = (dateTimeString: string): Date => {
  const year = parseInt(dateTimeString.substring(0, 4), 10)
  const month = parseInt(dateTimeString.substring(4, 6), 10) - 1
  const day = parseInt(dateTimeString.substring(6, 8), 10)
  const hours = parseInt(dateTimeString.substring(8, 10), 10)
  const minutes = parseInt(dateTimeString.substring(10, 12), 10)
  const seconds = parseInt(dateTimeString.substring(12, 14), 10)

  return new Date(year, month, day, hours, minutes, seconds)
}

type RecurrenceTimestampType = { dateNow: string; startTime: string; utc_offset: number }
export const calculateRecurrenceTimestamp = ({ dateNow, startTime, utc_offset }: RecurrenceTimestampType): string => {
  const currentDate = dayjs(dateNow, 'YYYYMMDDHHmmss')
  const currentTime = dateNow.slice(8)

  let recurrenceDatetime = currentDate
  if (currentTime < startTime) {
    recurrenceDatetime = currentDate.subtract(1, 'day')
  }

  const startHour = parseInt(startTime.slice(0, 2), 10)
  const startMinute = parseInt(startTime.slice(2, 4), 10)
  const startSecond = parseInt(startTime.slice(4, 6), 10)

  recurrenceDatetime = recurrenceDatetime.hour(startHour).minute(startMinute).second(startSecond)
  const recurrenceTimestamp = recurrenceDatetime.subtract(utc_offset, 'hour').format('YYYYMMDDHHmmss')
  return recurrenceTimestamp
}

interface ExtractUniqueUidsFromAudienceType {
  usersIds: string[]
  groupsIds: string[]
  tagsIds: string[]
  groups: IConfigStateGroups
  tags: ITag[]
}
export const extracUniqueUidsFromAudience = ({
  usersIds,
  groupsIds,
  tagsIds,
  groups,
  tags,
}: ExtractUniqueUidsFromAudienceType) => {
  const currentTags = tags.filter((tag) => tagsIds.includes(tag.sk))

  const uidsFromGroups = extractedUidsFromGroups(groupsIds, groups)
  const uidsFromTagsGroups = extractedUidsFromGroups(
    Array.from(new Set(currentTags.flatMap((tag) => tag?.groups ?? []))),
    groups
  )
  const currentTagsUsers = currentTags.flatMap((tag) => tag?.users ?? [])

  const uniqueUids = Array.from(new Set([...uidsFromGroups, ...uidsFromTagsGroups, ...currentTagsUsers, ...usersIds]))

  return uniqueUids
}

export const getUTCOffset = () => {
  return dayjs().utcOffset() / 60
}
export const isHtml = (text: string) => /<\/?[a-z][\s\S]*>/i.test(text)

type GetMediaCidArgs = {
  url: string
  cdn: string
  rid: string
}

/**
 * The comment `parent_cid` of one media item: the 16-char hash the media service puts in the file name.
 *
 * **Takes no uid, on purpose.** The cid is a property of the URL, not of who is looking at it. The path
 * is `${cdn}${rid}/user_uploads/<uploader_uid>_<hash>[-suffix].<ext>`, and that uid belongs to whoever
 * uploaded the file — on a group result, or after a retake, that is neither the viewer nor the result's
 * `created_by`. So the prefix is skipped entirely rather than matched against a uid the caller picks.
 *
 * That is what makes the cid the same for everyone: the author of a comment, the auditor reading it and
 * the delete that removes it all derive it from the same string. Passing a uid used to make it possible
 * to write under one cid and read under another — the comment then stayed invisible until reload, and
 * `deleteCommentsOfMedia` fired with `parent_cid: null`.
 */
export const getMediaCid = ({ url, cdn, rid }: GetMediaCidArgs): string | null => {
  const base = `${cdn}${rid}/user_uploads/`

  if (!url?.startsWith(base)) {
    return null
  }

  // First 16-char token that terminates the file name or is followed by a suffix separator.
  const match = url.substring(base.length).match(/_([a-zA-Z0-9]{16})(?=[-.]|$)/)

  return match ? match[1] : null
}

export const getProgressPercentage = (totalCount: number, doneCount: number) => {
  return totalCount > 0 ? Math.round((doneCount / totalCount) * 100) : 0
}

type GetDayIndicesInRangeArgs = {
  recurrenseStartTs: string
  recurrenseDeadlineTs: string
  frequencyType: number
  recurrenceDaysOfWeek: number[] | null
}
export const getDayIndicesInRange = ({
  recurrenseStartTs,
  recurrenseDeadlineTs,
  frequencyType,
  recurrenceDaysOfWeek,
}: GetDayIndicesInRangeArgs): number[] | string[] => {
  const startDate = dayjs(recurrenseStartTs, 'YYYYMMDDHHmmss')
  const endDate = dayjs(recurrenseDeadlineTs, 'YYYYMMDDHHmmss')
  const allDays = Array.from({ length: 7 }, (_, i) => i)

  if (!startDate.isValid() || !endDate.isValid()) {
    throw new Error('Invalid date format. Please use YYYYMMDDHHmmss')
  }

  if (frequencyType === FrequencyType.MONTH) {
    return [
      dayjs(startDate, 'YYYYMMDDHHmmss').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
      dayjs(endDate, 'YYYYMMDDHHmmss').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
    ]
  }

  const dayIndices: number[] = []

  if (endDate.isBefore(startDate, 'day')) {
    for (let date = startDate; date.day() <= 6; date = date.add(1, 'day')) {
      const dayIndex = date.day()
      if (!dayIndices.includes(dayIndex)) {
        dayIndices.push(dayIndex)
      }
    }

    for (
      let date = endDate.startOf('week');
      date.isBefore(endDate) || date.isSame(endDate, 'day');
      date = date.add(1, 'day')
    ) {
      const dayIndex = date.day()
      if (!dayIndices.includes(dayIndex)) {
        dayIndices.push(dayIndex)
      }
    }
  } else {
    for (let date = startDate; date.isBefore(endDate) || date.isSame(endDate, 'day'); date = date.add(1, 'day')) {
      const dayIndex = date.day()
      if (!dayIndices.includes(dayIndex)) {
        dayIndices.push(dayIndex)
      }
    }
  }

  if (frequencyType === FrequencyType.DAY) {
    return !recurrenceDaysOfWeek ? allDays : recurrenceDaysOfWeek
  }
  if (frequencyType === FrequencyType.WEEK) {
    return [dayIndices[0], dayIndices[dayIndices.length - 1]]
  }

  throw new Error('error')
}

export const formatDateWithOffset = (ts: string, format: string = 'DD/MM/YY HH:mm'): string => {
  return dayjs(ts).add(dayjs().utcOffset(), 'minute').format(format)
}

/**
 * Sorts tasks by dates or priority considering versions and recurrence
 * @param tasks - array of tasks to sort
 * @param sortingMode - sorting mode: keys.SORTING_MODES.START_DATE (by start date), keys.SORTING_MODES.END_DATE (by end date), or keys.SORTING_MODES.PRIORITY (by priority)
 * @returns sorted array of tasks
 *
 * Sorting logic:
 * - For sortingMode = keys.SORTING_MODES.START_DATE (by start date):
 *   - task.version !== 2: sort by from_ts (newest first)
 *   - task.version === 2 && !task.is_recurring: sort by from_ts (newest first)
 *   - task.version === 2 && task.is_recurring: sort by recurrence_ts (newest first)
 * - For sortingMode = keys.SORTING_MODES.END_DATE (by end date):
 *   - task.version !== 2: sort by to_ts (earliest deadline first)
 *   - task.version === 2 && !task.is_recurring: sort by deadline (earliest deadline first)
 *   - task.version === 2 && task.is_recurring: sort by recurrence_deadline (earliest deadline first)
 * - For sortingMode = keys.SORTING_MODES.PRIORITY (by priority):
 *   - Sort by priority: 3 (high) -> 2 (medium) -> 1 (low) -> null/undefined (none)
 *   - Within same priority, sort by start date (newest first)
 */
export const sortTasksByDueDate = <T extends IOverviewTask>(
  tasks: T[],
  sortingMode: number = keys.SORTING_MODES.START_DATE
) => {
  return tasks.sort((task, nextTask) => {
    const getTaskStartDate = (task: T): number => {
      // For old tasks (version != 2) use from_ts
      if (task.version !== 2) {
        if (task.from_ts) {
          return dayjs(task.from_ts, 'YYYYMMDDHHmmss').valueOf()
        }
      }

      // For new tasks (version = 2)
      if (task.version === 2) {
        // If task is recurring and has recurrence_ts
        if (task.is_recurring && task.recurrence_ts && task.recurrence_ts.length > 0) {
          // Take the last element of recurrence_ts array
          const lastRecurrence = task.recurrence_ts[task.recurrence_ts.length - 1]
          return dayjs(lastRecurrence.recurrence_ts, 'YYYYMMDDHHmmss').valueOf()
        }
        // If not recurring, use from_ts
        if (task.from_ts) {
          return dayjs(task.from_ts, 'YYYYMMDDHHmmss').valueOf()
        }
      }

      // Fallback - if nothing found, return 0
      return 0
    }

    const getTaskEndDate = (task: T): number => {
      // For old tasks (version != 2) use to_ts
      if (task.version !== 2) {
        if (task.to_ts) {
          return dayjs(task.to_ts, 'YYYYMMDDHHmmss').valueOf()
        }
      }

      // For new tasks (version = 2)
      if (task.version === 2) {
        // If task is recurring and has recurrence_ts
        if (task.is_recurring && task.recurrence_ts && task.recurrence_ts.length > 0) {
          // Take the last element of recurrence_ts array
          const lastRecurrence = task.recurrence_ts[task.recurrence_ts.length - 1]
          return dayjs(lastRecurrence.recurrence_deadline, 'YYYYMMDDHHmmss').valueOf()
        }
        // If not recurring, use deadline
        if (task.deadline) {
          return dayjs(task.deadline, 'YYYYMMDDHHmmss').valueOf()
        }
      }

      // Fallback - if nothing found, return 0
      return 0
    }

    if (sortingMode === keys.SORTING_MODES.START_DATE) {
      // Sort by start date (descending - newest first)
      const taskStartDate = getTaskStartDate(task)
      const nextTaskStartDate = getTaskStartDate(nextTask)
      return nextTaskStartDate - taskStartDate
    } else if (sortingMode === keys.SORTING_MODES.END_DATE) {
      // Sort by end date (ascending - earliest deadline first)
      const taskEndDate = getTaskEndDate(task)
      const nextTaskEndDate = getTaskEndDate(nextTask)
      return taskEndDate - nextTaskEndDate
    } else if (sortingMode === keys.SORTING_MODES.PRIORITY) {
      // Sort by priority: 3 (high) -> 2 (medium) -> 1 (low) -> null/undefined (none)
      const getTaskPriority = (task: T): number => {
        // For tasks v2 check priority field
        if (task.version === 2 && 'priority' in task) {
          return (task as any).priority ?? 0
        }
        // For old tasks, return 0 (no priority)
        return 0
      }

      const taskPriority = getTaskPriority(task)
      const nextTaskPriority = getTaskPriority(nextTask)

      // If priorities are different, sort by priority (high to low)
      if (taskPriority !== nextTaskPriority) {
        return nextTaskPriority - taskPriority
      }

      // If priorities are the same, sort by start date (newest first)
      const taskStartDate = getTaskStartDate(task)
      const nextTaskStartDate = getTaskStartDate(nextTask)
      return nextTaskStartDate - taskStartDate
    } else {
      // Default fallback - sort by start date
      const taskStartDate = getTaskStartDate(task)
      const nextTaskStartDate = getTaskStartDate(nextTask)
      return nextTaskStartDate - taskStartDate
    }
  })
}

/**
 * Extracts a thumbnail from a video URL by seeking to the first frame.
 * Requires the CDN to allow CORS (Access-Control-Allow-Origin).
 * Returns a blob URL on success, or null on failure (CORS block, decode error, etc.).
 */
export function extractVideoThumbnail(videoUrl: string, seekTime = 0.1): Promise<string | null> {
  return new Promise((resolve) => {
    const video = document.createElement('video')
    video.crossOrigin = 'anonymous'
    video.preload = 'metadata'
    video.muted = true
    video.playsInline = true

    const cleanup = () => {
      video.src = ''
      video.load()
    }

    video.addEventListener(
      'error',
      () => {
        cleanup()
        resolve(null)
      },
      { once: true }
    )

    video.addEventListener(
      'loadeddata',
      () => {
        video.currentTime = seekTime
      },
      { once: true }
    )

    video.addEventListener(
      'seeked',
      () => {
        try {
          const canvas = document.createElement('canvas')
          canvas.width = video.videoWidth || 640
          canvas.height = video.videoHeight || 360
          const ctx = canvas.getContext('2d')
          if (!ctx) {
            cleanup()
            resolve(null)
            return
          }
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
          canvas.toBlob(
            (blob) => {
              cleanup()
              resolve(blob ? URL.createObjectURL(blob) : null)
            },
            'image/jpeg',
            0.85
          )
        } catch {
          cleanup()
          resolve(null)
        }
      },
      { once: true }
    )

    video.src = videoUrl
    video.load()
  })
}

// Convert hex to rgba for box-shadow
export const withAlpha = (color: string, alpha: number) => {
  if (color.startsWith('#')) {
    const r = parseInt(color.slice(1, 3), 16)
    const g = parseInt(color.slice(3, 5), 16)
    const b = parseInt(color.slice(5, 7), 16)
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }
  const m = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/)
  if (m) return `rgba(${m[1]}, ${m[2]}, ${m[3]}, ${alpha})`
  return color
}
